module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-154.a4c83cd1.svg";